import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { apiRequest } from '../../../APIClient';

// on mount, fetch sensor section once if it hasn't been fetched before
export const useFetchSensorSection = () => {
  const hasFetched = useSelector(onboardingSelector.hasFetchedSensorSection);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOBSensors());
    }
  }, [dispatch, hasFetched]);
};
